<template>
    <div id="datatable-campaign-history">
        <v-data-table
            :headers="headers"
            :items="listCampaigns"
            :page="page"
            :pageCount="numberOfPages"
            :options.sync="options"
            :server-items-length="totalItems"
            :footer-props="{
                showFirstLastPage: true,
                'items-per-page-options': [10, 20, 50]
            }"
            dense
        >
            <template v-slot:[`item.imageURL`]="{ item }">
                <embed
                    v-if="String(item.imageURL).includes('.pdf')"
                    style="max-height: 100px; max-width: 200px"
                    :src="item.imageURL"
                />
                <div v-else-if="String(item.imageURL).includes('.ppt')">
                  <iframe :src="`https://view.officeapps.live.com/op/embed.aspx?src=${item.imageURL}`" width="250px" height="221px" frameborder="0">Este é um apresentação do <a target="_blank" href="https://office.com">Microsoft Office</a> incorporado, da plataforma <a target="_blank" href="https://office.com/webapps">Office</a>.</iframe>
                </div>
                <img
                    v-else
                    style="max-height: 100px; max-width: 200px"
                    :src="item.imageURL"
                />
                <img
                    v-if="item.isNew"
                    class="new-badge"
                    src="/images/badge_new.png"
                    width="50"
                    height="50"
                />
            </template>
            <template v-slot:[`item.promoEngineCampaignsStatusId`]="{ item }">
                <v-chip
                    :color="getStatusColor(item.promoEngineCampaignsStatusId)"
                    pill
                    dark
                    class="status-column"
                >
                    {{
                        getStatusDescription(item.promoEngineCampaignsStatusId)
                    }}
                </v-chip>
            </template>
            <template v-slot:[`item.startDate`]="{ item }">
                <span>{{ item.startDate | formatDateTimezone }}</span>
            </template>
            <template v-slot:[`item.endDate`]="{ item }">
                <span>{{ item.endDate | formatDateTimezone }}</span>
            </template>
            <template v-slot:[`item.diffDatesInDays`]="{ item }">
                <span>{{
                    getFormatedStringFromDays(item.diffDatesInDays)
                }}</span>
            </template>
            <template v-slot:[`item.actions-performance`]="{ item }">
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <span
                            @click="
                                $emit(
                                    'on-click-performance',
                                    item.promoEngineCampaignId
                                )
                            "
                            style="cursor: pointer"
                            v-bind="attrs"
                            v-on="on"
                        >
                            <img
                                src="/images/_SVGs/bo/list-box-outline.svg"
                                :alt="$t('b2b.promo-engine.performance')"
                                onload="SVGInject(this)"
                                width="20"
                                height="20"
                            />
                        </span>
                    </template>
                    <span>{{ $t("b2b.promo-engine.performance") }}</span>
                </v-tooltip>
            </template>
            <template v-slot:[`item.actions-view`]="{ item }">
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <span
                            v-if="item.canView"
                            @click="
                                $emit(
                                    'on-view-campaign',
                                    {
                                        promoEngineCampaignId: item.promoEngineCampaignId,
                                        isCompanyBellowTips: item.isCompanyBellowTips

                                    }
                                )
                            "
                            style="cursor: pointer"
                            v-bind="attrs"
                            v-on="on"
                        >
                            <img
                                src="/images/_SVGs/bo/eye.svg"
                                :alt="$t('b2b.promo-engine.view')"
                                onload="SVGInject(this)"
                                width="20"
                                height="20"
                            />
                        </span>
                    </template>
                    <span>{{ $t("b2b.promo-engine.view") }}</span>
                </v-tooltip>
            </template>
            <template v-slot:[`item.actions-edit`]="{ item }">
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <span
                        v-if="item.canModify"
                            @click="
                                $emit(
                                    'on-edit-campaign',
                                    {
                                        promoEngineCampaignId: item.promoEngineCampaignId,
                                        isCompanyBellowTips: item.isCompanyBellowTips

                                    }
                                )
                            "
                            style="cursor: pointer"
                            v-bind="attrs"
                            v-on="on"
                        >
                            <img
                                src="/images/_SVGs/bo/edit_pencil.svg"
                                :alt="$t('edit')"
                                onload="SVGInject(this)"
                                width="20"
                                height="20"
                            />
                        </span>
                    </template>
                    <span>{{ $t("edit") }}</span>
                </v-tooltip>
            </template>
        </v-data-table>
    </div>
</template>

<script>
import moment from "moment";
export default {
    props: {
        listCampaigns: Array | Object,
        totalItems: Number | String,
    },
    data() {
        return {
            page: 1,
            numberOfPages: 0,
            options: {
                page: 1,
                itemsPerPage: 10,
                sortBy: [],
            },
        };
    },
    watch: {
        "options.page": {
            handler() {
                this.$emit("alterTable", this.options);
            },
        },
        "options.itemsPerPage": {
            handler() {
                this.$emit("alterTable", this.options);
            },
        },
        "options.sortBy": {
            handler() {
                this.$emit("alterTable", this.options);
            },
        },
    },
    computed: {
        isCompanyBellowTips() {
            return (
                this.listCampaigns.length > 0 &&
                this.listCampaigns[0].isCompanyBellowTips
            );
        },
        headers() {
            return [
                {
                    text: this.$t("b2b.promo-engine.campaign"),
                    align: "start",
                    value: "imageURL",
                    width: "10%",
                    class: "header-table-color",
                    sortable: false,
                },
                {
                    text: this.$t("b2b.promo-engine.campaign-type"),
                    value: "promoEngineCampaignType.description",
                    width: "10%",
                    class: "header-table-color",
                    align: this.isCompanyBellowTips ? "start" : " d-none",
                    sortable: false,
                },
                {
                    text: this.$t("b2b.promo-engine.campaign-name"),
                    align: "start",
                    value: "title",
                    width: "10%",
                    class: "header-table-color",
                    sortable: true,
                },
                {
                    text: this.$t("b2b.promo-engine.start-date"),
                    align: "start",
                    value: "startDate",
                    width: "10%",
                    class: "header-table-color",
                    sortable: true,
                },
                {
                    text: this.$t("b2b.promo-engine.end-date"),
                    align: "start",
                    value: "endDate",
                    width: "10%",
                    class: "header-table-color",
                    sortable: true,
                },
                {
                    text: this.$t("b2b.promo-engine.status"),
                    align: "start",
                    value: "promoEngineCampaignsStatusId",
                    width: "10%",
                    class: "header-table-color",
                    sortable: true,
                },
                {
                    text: this.$t("b2b.promo-engine.period"),
                    align: "start",
                    value: "diffDatesInDays",
                    width: "10%",
                    class: "header-table-color",
                    sortable: false,
                },
                {
                    text: this.$t("b2b.promo-engine.performance"),
                    value: "actions-performance",
                    sortable: false,
                    align: this.isCompanyBellowTips ? "center" : " d-none",
                    width: "3%",
                    class: "header-table-color",
                },
                {
                    text: this.$t("b2b.promo-engine.view"),
                    value: "actions-view",
                    width: "10%",
                    class: "header-table-color",
                    align: this.isCompanyBellowTips ? " d-none" : "center",
                    sortable: true,
                },
                {
                    text: this.$t("b2b.promo-engine.edit"),
                    value: "actions-edit",
                    sortable: false,
                    align: "center",
                    width: "3%",
                    class: "header-table-color",
                },
            ];
        },
    },
    filters: {
        formatDateTimezone(value) {
            if (!value) return "";
            return moment.utc(value).local().format("DD/MM/YYYY HH:mm");
        }
    },
    methods: {
        getStatusColor(status) {
            switch (status) {
                case 1:
                    return "primary";
                case 2:
                    return "green";
                case 3:
                    return "orange";
            }
        },
        getStatusDescription(item) {
            switch (item) {
                case 1:
                    return this.$t("b2b.promo-engine.saved");
                case 2:
                    return this.$t("b2b.promo-engine.published");
                case 3:
                    return this.$t("b2b.promo-engine.expired");
            }
        },
        getFormatedStringFromDays(numberOfDays) {
            var years = Math.floor(numberOfDays / 365);
            var months = Math.floor((numberOfDays % 365) / 30);
            var days = Math.floor((numberOfDays % 365) % 30);

            var yearsDisplay =
                years > 0
                    ? years +
                      (years == 1
                          ? ` ${this.$t("b2b.promo-engine.year")}, `
                          : ` ${this.$t("b2b.promo-engine.years")}, `)
                    : "";
            var monthsDisplay =
                months > 0
                    ? months +
                      (months == 1
                          ? ` ${this.$t("b2b.promo-engine.month")}, `
                          : ` ${this.$t("b2b.promo-engine.months")}, `)
                    : "";
            var daysDisplay =
                days > 0
                    ? days +
                      (days == 1
                          ? ` ${this.$t("b2b.promo-engine.day")}`
                          : ` ${this.$t("b2b.promo-engine.days")}`)
                    : "";
            return yearsDisplay + monthsDisplay + daysDisplay;
        },
    },
};
</script>

<style lang="scss">
@import "@sass/_variables.scss";
#datatable-campaign-history {
    tr {
        height: 42px;
    }
    .status-column {
        width: 100%;
        margin: 0 auto;
        text-align: center;
        .v-chip__content {
            margin: 0 auto;
            text-align: center;
            font-size: 12px;
        }
    }
    .new-badge {
        position: absolute;
        left: 20px;
    }
}
</style>
